const EstabelecimentoOptions = [
  { id: 1, text: "Bela Vista", value:"BelaVista" },
  { id: 51, text: "Itaim", value:"Itaim" },
  { id: 73, text: "Jardins", value:"Jardins" },
  { id: 72, text: "Brasilia", value:"Brasilia" }
];

export { EstabelecimentoOptions};
